import React, { createContext, useContext, useState } from 'react'

const translations = {
  en: {
    nav: {
      home: 'Home',
      skills: 'Skills',
      projects: 'Projects',
      services: 'Services',
      connect: "Let's Connect",
    },
    header: {
      welcome: 'Welcome to my Portfolio',
      greeting: "Hey! I'm Sofiane",
      roles: ['App Developer', 'Web Designer', 'UI/UX Designer'],
      bio: 'Based in Hong Kong, I design and build modern web & mobile applications with a focus on clean code, smooth interactions and impactful visual design.',
      stats: [
        { value: '4+', label: 'Years Exp.' },
        { value: '30+', label: 'Projects' },
        { value: '15+', label: 'Clients' },
      ],
    },
    skills: {
      title: 'Skills',
      desc1: 'Keen in solving problems and building solutions',
      desc2: 'I like to code things from scratch and enjoy bringing ideas to life in the browser.',
      categories: ['Frontend Development', 'Backend Development', 'UI Design', 'Brand Identity'],
      stackTitle: 'Tech Stack',
      impact: [
        { end: 10,  suffix: '+',  label: 'Technologies' },
        { end: 10,  suffix: '+',  label: 'Projects Delivered' },
        { end: 4,   suffix: '',   label: 'Areas of Expertise' },
        { end: 100, suffix: '%',  label: 'Mobile-first' },
      ],
    },
    projects: {
      title: 'Projects',
      desc: 'These projects are very graphical in order to match the web standards of today. I created many projects for clients and studies, using JavaScript, React, PHP and WordPress.',
      role: 'Design & Development',
    },
    services: {
      title: 'Services',
      desc: 'You can order from the form below. For information and quotes, it is also possible to send a mail.',
      items: [
        { title: 'Development', text: 'I build applications and websites for B2B and B2C, from simple showcase sites to complex multi-page applications.' },
        { title: 'Responsive Design', text: 'Important nowadays, I offer to rebuild your applications and websites to responsive design AND mobile-first in order to optimize SEO.' },
        { title: 'Web Design', text: 'Your application or website design will meet visual and accessibility standards while respecting your specifications.' },
        { title: 'Creative Design', text: 'Take advantage of the latest design trends with full follow-up from sketch to the production of your website.' },
        { title: 'Quick Support', text: 'Support is provided to ensure smooth access to your applications and websites over time.' },
        { title: 'Branding Identity', text: 'I provide a simple, satisfying and logical branding identity, combining current trends with the values of your brand.' },
      ],
    },
    contact: {
      title: 'Get In Touch',
      subtitle: "Got a project in mind? Let's build something great together.",
      name: 'Name',
      email: 'Email address',
      message: 'Message',
      send: 'Send Message',
      sending: 'Sending...',
      success: 'Message sent! I\'ll get back to you soon.',
      error: 'Oops, something went wrong. Please try again.',
    },
    footer: {
      tagline: 'Crafted with React & Passion',
      copyright: 'Copyright 2026: All Rights Reserved',
    },
  },

  fr: {
    nav: {
      home: 'Accueil',
      skills: 'Compétences',
      projects: 'Projets',
      services: 'Services',
      connect: 'Me Contacter',
    },
    header: {
      welcome: 'Bienvenue sur mon Portfolio',
      greeting: 'Salut ! Je suis Sofiane',
      roles: ['Développeur App', 'Designer Web', 'Designer UI/UX'],
      bio: 'Basé à Hong Kong, je conçois et développe des applications web & mobiles modernes, avec un accent sur le code propre, les interactions fluides et un design visuel percutant.',
      stats: [
        { value: '4+', label: "Ans d'expérience" },
        { value: '30+', label: 'Projets' },
        { value: '15+', label: 'Clients' },
      ],
    },
    skills: {
      title: 'Compétences',
      desc1: 'Passionné par la résolution de problèmes et la création de solutions',
      desc2: "J'aime coder de zéro et donner vie aux idées dans le navigateur.",
      categories: ['Développement Frontend', 'Développement Backend', 'Design UI', 'Identité de Marque'],
      stackTitle: 'Technologies',
      impact: [
        { end: 10,  suffix: '+',  label: 'Technologies' },
        { end: 10,  suffix: '+',  label: 'Projets Livrés' },
        { end: 4,   suffix: '',   label: "Domaines d'Expertise" },
        { end: 100, suffix: '%',  label: 'Mobile-first' },
      ],
    },
    projects: {
      title: 'Projets',
      desc: "Ces projets sont très graphiques afin de correspondre aux standards du web d'aujourd'hui. J'ai créé de nombreux projets pour des clients ou dans le cadre de mes études, en utilisant JavaScript, React, PHP et WordPress.",
      role: 'Design & Développement',
    },
    services: {
      title: 'Services',
      desc: 'Vous pouvez passer commande via le formulaire ci-dessous. Pour des informations et des devis, il est aussi possible de laisser un mail.',
      items: [
        { title: 'Développement', text: "Je construis des applications et sites web pour le B2B et le B2C, de simples vitrines jusqu'à des sites complexes multi-pages." },
        { title: 'Responsive Design', text: "Primordial aujourd'hui, je propose de reconstruire vos applications en responsive design ET mobile-first afin d'assurer un SEO optimal." },
        { title: 'Web Design', text: "La conception de votre site web répondra aux normes visuelles et d'accessibilité tout en respectant votre cahier des charges." },
        { title: 'Design Créatif', text: "Profitez des dernières tendances en termes de design et du suivi de la maquette jusqu'à la mise en production." },
        { title: 'Support Rapide', text: 'Le support est fourni lors de mes prestations afin de garantir un accès fluide à votre application et site internet.' },
        { title: 'Identité de Marque', text: 'Je fournis une image de marque simple, logique et satisfaisante, associant tendances et valeurs de votre marque.' },
      ],
    },
    contact: {
      title: 'Entrons en Contact',
      subtitle: "Vous avez un projet en tête\u00a0? Construisons quelque chose d'incroyable ensemble.",
      name: 'Nom',
      email: 'Adresse email',
      message: 'Message',
      send: 'Envoyer le message',
      sending: 'Envoi en cours...',
      success: 'Message envoyé ! Je vous recontacte très vite.',
      error: 'Oups, une erreur est survenue. Veuillez réessayer.',
    },
    footer: {
      tagline: 'Créé avec React & Passion',
      copyright: 'Copyright 2026 : Tous droits réservés',
    },
  },

  zh: {
    nav: {
      home: '首页',
      skills: '技能',
      projects: '项目',
      services: '服务',
      connect: '联系我',
    },
    header: {
      welcome: '欢迎来到我的作品集',
      greeting: '你好！我是 Sofiane',
      roles: ['App 开发者', 'Web 设计师', 'UI/UX 设计师'],
      bio: '常驻香港，我专注于设计和构建现代 Web 及移动应用，注重代码质量、流畅交互与视觉冲击力。',
      stats: [
        { value: '4+', label: '年经验' },
        { value: '30+', label: '项目' },
        { value: '15+', label: '客户' },
      ],
    },
    skills: {
      title: '技能',
      desc1: '热衷于解决问题和构建解决方案',
      desc2: '我喜欢从零开始编写代码，享受将创意变为现实的过程。',
      categories: ['前端开发', '后端开发', 'UI 设计', '品牌标识'],
      stackTitle: '技术栈',
      impact: [
        { end: 10,  suffix: '+',  label: '项技术' },
        { end: 10,  suffix: '+',  label: '项目交付' },
        { end: 4,   suffix: '',   label: '专业领域' },
        { end: 100, suffix: '%',  label: '移动优先' },
      ],
    },
    projects: {
      title: '项目',
      desc: '这些项目注重视觉效果，以匹配当今的网页标准。我为客户和学习目的创建了许多项目，使用了 JavaScript、React、PHP 和 WordPress。',
      role: '设计与开发',
    },
    services: {
      title: '服务',
      desc: '您可以通过下方表单下单，如需了解信息和报价，也可以发送邮件联系。',
      items: [
        { title: '开发', text: '我为 B2B 和 B2C 构建应用程序和网站，从简单的展示网站到复杂的多页面应用程序。' },
        { title: '响应式设计', text: '如今至关重要，我提供将您的应用和网站改造为响应式设计及移动优先方案，以优化搜索引擎排名。' },
        { title: '网页设计', text: '您的网站或应用设计将符合视觉规范和无障碍要求，同时遵守您的需求说明。' },
        { title: '创意设计', text: '把握最新设计趋势，从草图到上线全程跟进，确保您的网站完美呈现。' },
        { title: '快速支持', text: '提供持续支持，确保您的应用和网站长期稳定运行。' },
        { title: '品牌标识', text: '我提供简洁、合理且令人满意的品牌标识，融合潮流与品牌价值。' },
      ],
    },
    contact: {
      title: '与我联系',
      subtitle: '有项目想法？让我们一起打造出色的产品吧。',
      name: '姓名',
      email: '电子邮箱',
      message: '留言',
      send: '发送消息',
      sending: '发送中…',
      success: '消息已发送！我会尽快回复您。',
      error: '出错了，请重试。',
    },
    footer: {
      tagline: '用 React 与热情打造',
      copyright: 'Copyright 2026：保留所有权利',
    },
  },
}

const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en')
  const t = translations[lang]
  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
